
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingBooker.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
class EvBookingBooker extends compose(_StatefulSection) {
    templateString: any = template;

    bookerInput: MdsLax<InstanceType<typeof SearchSelect>>;

    protected afterSetData() {
        let data = this.currentData as VAM2types.EvBookingBooker;
    }

    protected onDirtyChange(currentState: boolean) {
        let data = this.currentData as VAM2types.EvBookingBooker;
    }

    protected _onChanged(key: string, value: any) {
        // wird bei jedem onchanged aufgerufen
        let data = this.currentData as VAM2types.EvBookingBooker;
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        if (this.hasFeature("EvBooking/Booker")) {
            this.bookerInput.setCallfunction("Webtool_API_EvBooking__GetBookerListValues");
        }
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //console.debug(this.id + " startup, Feature?", this.hasModule("EvBooking/Booker"));

        if (this.hasFeature("EvBooking/Booker")) {
            this.bookerInput.setValue(window.sessionInfo?.sessionData?.CurrentEmployeeId, true);
            //console.debug("Loading Booker");
            //this.bookerInput.setUrl("EvBookingEditor/GetBookerListValues");
            
            //this.bookerInput.loadListValues();
        }
    }
}

export default mdsWidget(EvBookingBooker);